import { useState, useEffect } from "react";
import axios from "axios";
import { branding } from "../../config";

export default function RentFormPublic() {
    const [fullName, setFullName] = useState("");
    const [address, setAddress] = useState("");
    const [paymentAmount, setPaymentAmount] = useState("");
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [submitMessage, setSubmitMessage] = useState("");
    const [submitSuccess, setSubmitSuccess] = useState(false);

    useEffect(() => {
        // TODO: Fetch rent form config if needed
        setLoading(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!fullName.trim() || !address.trim() || !paymentAmount.trim()) {
            setSubmitMessage("Full name, address, and payment amount are required");
            setSubmitSuccess(false);
            setSubmitted(true);
            return;
        }

        setSubmitting(true);
        try {
            // Submit rent payment info to backend
            await axios.post("/api/rent/submit", {
                full_name: fullName.trim(),
                address: address.trim(),
                payment_amount: parseFloat(paymentAmount),
                additional_notes: additionalNotes.trim()
            });
            
            setSubmitMessage("Redirecting...");
            setSubmitSuccess(true);
            setSubmitted(true);
            
            // Redirect to PayPal after a short delay
            setTimeout(() => {
                window.location.href = "https://www.paypal.com/donate/?hosted_button_id=M4YZKC9UB5T5G";
            }, 1500);
        } catch (error) {
            console.error("Error submitting rent payment:", error);
            setSubmitMessage("Failed to submit rent payment. Please try again later.");
            setSubmitSuccess(false);
            setSubmitted(true);
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {
        return null;
    }

    return (
        <section style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <div className="container my-5">
                <div
                    style={{
                        maxWidth: "600px",
                        margin: "0 auto",
                        textAlign: "center",
                    }}
                >
                    <h2
                        style={{
                            fontWeight: "700",
                            marginBottom: "20px",
                            letterSpacing: "1px",
                            fontSize: "2rem",
                            color: "var(--primary-color)"
                        }}
                    >
                        Pay Rent
                    </h2>
                
                {submitted ? (
                    // Show message after submission
                    <div
                        style={{
                            padding: "30px",
                            borderRadius: "12px",
                            backgroundColor: "#f8f9fa",
                            border: "2px solid var(--primary-color)",
                            marginTop: "20px"
                        }}
                    >
                        <h4
                            style={{
                                color: "#333",
                                marginBottom: "10px",
                                fontWeight: "600"
                            }}
                        >
                            {submitSuccess ? "✓ Success!" : "✗ Error"}
                        </h4>
                        <p
                            style={{
                                color: "#333",
                                fontSize: "1.1rem",
                                margin: 0,
                                fontWeight: "500"
                            }}
                        >
                            {submitMessage}
                        </p>
                        {submitSuccess && (
                            <p
                                style={{
                                    color: "#666",
                                    fontSize: "0.95rem",
                                    marginTop: "15px",
                                    marginBottom: 0
                                }}
                            >
                                If not redirected automatically,{" "}
                                <a
                                    href="https://www.paypal.com/donate/?hosted_button_id=M4YZKC9UB5T5G"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "var(--primary-color)",
                                        textDecoration: "underline",
                                        fontWeight: "600"
                                    }}
                                >
                                    click here
                                </a>
                            </p>
                        )}
                    </div>
                ) : (
                    // Show form before submission
                    <>
                        <p
                            style={{
                                fontSize: "1.1rem",
                                marginBottom: "10px",
                                opacity: 0.85,
                                color: "#666"
                            }}
                        >
                            Submit your rent payment information below
                        </p>
                        <p
                            style={{
                                fontSize: "0.95rem",
                                marginBottom: "30px",
                                opacity: 0.75,
                                color: "#999",
                                fontStyle: "italic"
                            }}
                        >
                            For our records, please submit the following information before being redirected to the payment page.
                        </p>
                        
                        <form onSubmit={handleSubmit} className="row g-3 justify-content-center">
                            <div className="col-md-10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Full Name"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    required
                                    style={{
                                        borderRadius: "8px",
                                        border: "1px solid #e0e0e0",
                                        padding: "12px 16px",
                                        fontSize: "1rem"
                                    }}
                                />
                            </div>
                            <div className="col-md-10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    required
                                    style={{
                                        borderRadius: "8px",
                                        border: "1px solid #e0e0e0",
                                        padding: "12px 16px",
                                        fontSize: "1rem"
                                    }}
                                />
                            </div>
                            <div className="col-md-10">
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Payment Amount"
                                    value={paymentAmount}
                                    onChange={(e) => setPaymentAmount(e.target.value)}
                                    required
                                    step="0.01"
                                    min="0"
                                    style={{
                                        borderRadius: "8px",
                                        border: "1px solid #e0e0e0",
                                        padding: "12px 16px",
                                        fontSize: "1rem"
                                    }}
                                />
                            </div>
                            <div className="col-md-10">
                                <textarea
                                    className="form-control"
                                    placeholder="Additional Notes (Optional)"
                                    value={additionalNotes}
                                    onChange={(e) => setAdditionalNotes(e.target.value)}
                                    rows="4"
                                    style={{
                                        borderRadius: "8px",
                                        border: "1px solid #e0e0e0",
                                        padding: "12px 16px",
                                        fontSize: "1rem"
                                    }}
                                />
                            </div>
                            <div className="col-md-10">
                                <button
                                    type="submit"
                                    className="btn btn-custom-filled w-100"
                                    disabled={submitting}
                                    style={{
                                        borderRadius: "8px",
                                        padding: "12px 16px",
                                        fontWeight: "600",
                                        fontSize: "1rem"
                                    }}
                                >
                                    {submitting ? "Submitting..." : "Submit Information"}
                                </button>
                                <p
                                    style={{
                                        fontSize: "0.9rem",
                                        marginTop: "15px",
                                        opacity: 0.75,
                                        color: "#999",
                                        margin: "15px 0 0 0"
                                    }}
                                >
                                    This form is not a payment form. After you press <em>Submit</em>, you will be redirected to the PayPal payment page where you can complete the payment.
                                </p>
                            </div>
                        </form>
                    </>
                )}
                </div>
            </div>
        </section>
    );
}